<template lang="html">
  <div>
    <van-row>
      <van-col
        :span="span"
        v-for="(imgId, index) in imgIds"
        :key="index"
      >
        <Photo
          source="cdn"
          :img-id="imgId"
          @photo-gotten="photoGotten"
          @preview="previewPhotos"
        />
      </van-col>
    </van-row>
  </div>
</template>

<script>
  import Photo from './photo.vue'
  import Vue from 'vue'
  import { Row, Col } from 'vant'
  import { ImagePreview } from 'vant'
  Vue.use(Row).use(Col)
  Vue.use(ImagePreview)

  export default {
    components: {
      Photo,
    },
    data () {
      return {
        photos: []
      }
    },
    props: {
      imgIds: Array
    },
    computed: {
      span () {
        let span = 8
        let length = this.imgIds.length
        if (length < 3) {
          span = 24 / length
        }
        return span
      },
    },
    methods: {
      photoGotten (src) {
        this.photos.push(src)
      },
      previewPhotos (src) {
        ImagePreview({
          images: this.photos,
          startPosition: this.photos.indexOf(src)
        })
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
